import {BarChart, MapChart, Table} from "../chart";
import React from "react";
import {Filters} from "./shared/Filters/Filters";
import {useFetchData} from "./shared/useFetchData";

const NieruchomosciNaSprzedazDashboard = () => {
    const [initData, data, filters, activeFilters, setFilters] = useFetchData('NIERUCHOMOSCI_NA_SPRZEDAZ');

    return (
        <div className="container">
            <div className="title-container">
                <h2 className={'title'}>Nieruchomości na sprzedaż</h2>
            </div>
            <Filters data={filters} setFilters={setFilters}/>
            <div className="visualization-container">
                <BarChart data={data}
                          groupBy={'status'}
                          mainKey={'organization'}
                          value={'askingPrice'}
                          title={'Status'}
                          valueFormat={'currency'}/>
                <BarChart data={data}
                          groupBy={'type'}
                          mainKey={'organization'}
                          value={'askingPrice'}
                          title={'Typ nieruchomści'}
                          valueFormat={'currency'}/>
            </div>
            <div className="visualization-container">
                <MapChart data={initData}
                          filters={filters}
                          activeFilters={activeFilters}
                          valueFormat={'currency'}
                          groupBy={'organization'}
                          value={'askingPrice'}
                          featureClick={setFilters}/>
                <BarChart data={data}
                          groupBy={'organization'}
                          value={'askingPrice'}
                          title={'Gmina'}
                          valueFormat={'currency'}
                          layout={'horizontal'}/>
            </div>
        </div>
    )
}

export {NieruchomosciNaSprzedazDashboard as default}